import { render, staticRenderFns } from "./Cloud_Services.vue?vue&type=template&id=89b4b312&scoped=true&"
import script from "./Cloud_Services.vue?vue&type=script&lang=js&"
export * from "./Cloud_Services.vue?vue&type=script&lang=js&"
import style0 from "./Cloud_Services.vue?vue&type=style&index=0&id=89b4b312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b4b312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
